module.exports = __webpack_public_path__ + "static/media/Walk-through._Discoverjpg_2.c30684c6.jpg";